import type { ReactNode } from 'react';
import { Paper, styled } from '@mui/material';

const Card = styled(Paper)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    borderRadius: theme.spacing(2),
}));

interface BankListCardProps {
    readonly children: ReactNode;
}

/** The bordered card the sync list and the progress dialog hold their bank rows in. */
export default function BankListCard({ children }: Readonly<BankListCardProps>) {
    return <Card variant="outlined">{children}</Card>;
}
